<template>
    <div class="driver-instructions-required-panel">
        <div class="background" @click="close" />
        <div class="wrapper">
            <p style="font-size:2em">🏘️ 🏢 </p>
            <p style="margin-bottom:10px">
                Tell us the
                <b>house number</b> or
                <b>building name</b> or other instructions so the
                delivery driver can find the address.
            </p>
            <p class="control" style="margin-bottom:10px">
                <textarea class="textarea is-fullwidth" rows="2" v-model="instructions"
                    placeholder="📍 House #175/15 Soi 11" />
            </p>
            <p class="has-text-info" style="margin-bottom:10px; font-size:0.8em; font-weight:450">
                Don't know your address? You can send us your
                coordinates or a google map link to your exact location.
            </p>
            <p class="button is-fullwidth is-success is-medium" :disabled="!validInstructions" @click="submit">
                Submit Order
            </p>
        </div>
    </div>
</template>


<script>
export default {
    name: "DriverInstructionsRequiredPanel",
    data() {
        return {
            instructions: null
        };
    },
    computed: {
        validInstructions() {
            if (!this.instructions) return false;
            return this.instructions.length >= 1;
        },
        username() {
            return this.$store.getters.getNameAndNumber;
        },
    },
    mounted() {
        // var msg = `🤔📍 Force Instructions [ ${this.username} ]`
        // this.sendSuperuserNotification(msg);
    },
    methods: {
        submit() {
            // var msg = `📍[${this.instructions}] for [${this.username}]`
            // this.sendSuperuserNotification(msg);
            this.$emit("submit", this.instructions);
        },
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.background {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(1px);
}

.wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px;
    width: 100vw;
    max-width: 700px;
    /* background-color: rgb(250, 215, 156); */
    background-color: lightgoldenrodyellow;
}

.button {
    padding: 8px;
}
</style>